import Entity from './entity'

export default class HandoverSessionDetail extends Entity<number>{
    code:string;
    refCode :string;
    refTypeCode :string;
    transferredBy :number;
    transferredTime : Date;
    deliveryPartnerName :string;
    numOfPackages :number;
    status:string;
    canDelete: boolean;
    transferred : boolean;
    sessionType:string;
    transferredUserName:string;
    creatorUserName:string;
    notDone: boolean;
    creatorUserId : string;
    creationTime : Date;
    note:string;
    refTypeName:string;
    statusName:string;
    items=[];
}
